import React from 'react';

const backdrop = ( props ) => (<div className='backdrop' onClick={props.clicked}></div>);

export default backdrop